module.exports = __webpack_public_path__ + "img/_DSC6723.91a5ea2f.jpg";